export enum Color {
  white = 'white',
  primary = 'primary',
}

export type Props = {
  className?: string;
  color?: keyof typeof Color;
};
